/**
 * Under every search box (RE-35, settled with Matthew 27 October). While the
 * search runs, the spinner turns INSIDE the box (each box wraps its input in
 * .search-box), where the eye already is; "Searching…" is said to screen
 * readers only. When it came back empty: No matches for "what was typed". -
 * so the person knows the search ran. Nothing when the box is empty or
 * something was found.
 */
export function SearchFeedback({ query, searching, found }: { query: string; searching: boolean; found: number }) {
  const typed = query.trim();
  if (!typed) return null;
  if (searching) {
    return (
      <span className="visually-hidden" role="status">
        Searching…
      </span>
    );
  }
  if (found > 0) return null;
  return (
    <p className="search-note" role="status">
      No matches for “{typed}”.
    </p>
  );
}
